module.exports = __webpack_public_path__ + "static/img/lb3.7abd61b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb3.png
// module id = XQph
// module chunks = 0